<template>
<div class="info">
	<div class="title">发票信息：
		{{info.invoiceType=='NOT'||!info.invoiceType?'不开发票':(info.invoiceType=='PLAIN'?'普票':'专票')}}
	</div>
	<Form :label-width="150" class="mt15 info" v-if="info.invoiceType&&info.invoiceType!='NOT'">
		<FormItem :label="type=='COMPANY'?'公司名称：':'开票人姓名：'" class="w600">
			{{info.invoiceName}}
		</FormItem>
		<div v-if="type=='COMPANY'">
			<FormItem label="统一社会信用代码：" class="w600">
				{{info.invoiceUniqueCode}}
			</FormItem>
			<FormItem label="地址：" class="w600">
				{{info.invoiceAddress}}
			</FormItem>
			<FormItem label="电话：" class="w600">
				{{info.invoicePhone}}
			</FormItem>
			<FormItem label="开户行：" class="w600">
				{{info.openingBankName}}
			</FormItem>
			<FormItem label="银行账号：" class="w600">
				{{info.openingBankAccount}}
			</FormItem>
		</div>
		<!-- <FormItem label="电子邮箱：" class="w600" v-if="info.invoiceDeliverEmail">
			{{info.invoiceDeliverEmail}}
		</FormItem> -->
		<FormItem label="邮寄地址：" class="w600" v-if="info.invoiceDeliverAddress">
			{{info.invoiceDeliverAddress}}
		</FormItem>
	</Form>
</div>
</template>
<script>
export default {
	props:{
		info:{
			type:Object,
			default(){
				return {}
			}
		},
		type:{
			type:String,
			default:'COMPANY' // 企业COMPANY，个人PERSON
		},
	},
}
</script>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/common/InvoiceInfo.vue